/* Shared by Astro and Ghost. Main section anchors never intercept navigation. */
(function () {
    function initNavigation() {
        document.querySelectorAll('[data-premium-nav]').forEach(function (header) {
            if (header.hasAttribute('data-nav-ready')) return;
            header.setAttribute('data-nav-ready', '');
            var desktop = window.matchMedia('(min-width: 1100px)');
            var canHover = window.matchMedia('(hover: hover)');
            var sections = Array.from(header.querySelectorAll('[data-nav-section]'));
            var drawer = header.querySelector('[data-nav-drawer]');
            var toggle = header.querySelector('[data-drawer-toggle]');
            var backdrop = header.querySelector('[data-nav-backdrop]');
            var closeTimer;
            var restoreFocus = false;
            var oldOverflow = '';
            var previousFocus;

            function setSection(section, open) {
                section.toggleAttribute('data-open', open);
                section.querySelector('.gt-mega').inert = !open;
                section.querySelectorAll('[data-nav-link], [data-nav-toggle]').forEach(function (link) {
                    link.setAttribute('aria-expanded', String(open));
                });
            }
            function closeSections() {
                clearTimeout(closeTimer);
                sections.forEach(function (section) { setSection(section, false); });
                header.removeAttribute('data-menu-open');
            }
            function openSection(section) {
                if (!desktop.matches) return;
                clearTimeout(closeTimer);
                if (section.hasAttribute('data-open')) return;
                closeSections();
                setSection(section, true);
                header.setAttribute('data-menu-open', '');
            }
            sections.forEach(function (section) {
                var link = section.querySelector('[data-nav-link]');
                section.addEventListener('pointerenter', function () {
                    if (canHover.matches) openSection(section);
                });
                section.addEventListener('pointerleave', function () {
                    closeTimer = setTimeout(function () {
                        if (!section.contains(document.activeElement)) closeSections();
                    }, 180);
                });
                section.addEventListener('focusin', function (event) {
                    if (event.target.closest('[data-nav-toggle]')) return;
                    if (!restoreFocus) openSection(section);
                });
                section.addEventListener('focusout', function (event) {
                    if (!section.contains(event.relatedTarget)) closeSections();
                });
                link.addEventListener('keydown', function (event) {
                    if (event.key === 'ArrowDown') {
                        event.preventDefault();
                        openSection(section);
                        section.querySelector('.gt-mega a').focus();
                    }
                });
                section.querySelector('[data-nav-toggle]').addEventListener('click', function () {
                    // Touch controls are distinct from the direct page link.
                    if (section.hasAttribute('data-open')) closeSections();
                    else openSection(section);
                });
            });
            function closeDrawer(returnFocus) {
                if (!header.hasAttribute('data-drawer-open')) return;
                header.removeAttribute('data-drawer-open');
                drawer.inert = true;
                toggle.setAttribute('aria-expanded', 'false');
                toggle.setAttribute('aria-label', 'Open navigation');
                document.body.style.overflow = oldOverflow;
                if (returnFocus && previousFocus) previousFocus.focus();
            }
            toggle.addEventListener('click', function () {
                if (header.hasAttribute('data-drawer-open')) { closeDrawer(true); return; }
                closeSections();
                previousFocus = document.activeElement;
                oldOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
                header.setAttribute('data-drawer-open', '');
                drawer.inert = false;
                toggle.setAttribute('aria-expanded', 'true');
                toggle.setAttribute('aria-label', 'Close navigation');
                drawer.querySelector('[data-drawer-close]').focus();
            });
            header.querySelector('[data-drawer-close]').addEventListener('click', function () { closeDrawer(true); });
            backdrop.addEventListener('click', function () { closeSections(); closeDrawer(true); });
            header.querySelectorAll('[data-mobile-expand]').forEach(function (button) {
                button.addEventListener('click', function () {
                    var open = button.getAttribute('aria-expanded') !== 'true';
                    button.setAttribute('aria-expanded', String(open));
                    document.getElementById(button.getAttribute('aria-controls')).hidden = !open;
                });
            });
            drawer.querySelectorAll('a').forEach(function (link) {
                link.addEventListener('click', function () { closeDrawer(false); });
            });
            header.querySelectorAll('[data-plan-trip]').forEach(function (button) {
                button.addEventListener('click', function () {
                    closeSections();
                    closeDrawer(false);
                    window.dispatchEvent(new CustomEvent('open-lead-form', { detail: { cta_name: button.getAttribute('data-plan-trip') } }));
                });
            });
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    var active = sections.find(function (section) { return section.hasAttribute('data-open'); });
                    closeSections();
                    closeDrawer(true);
                    if (active) {
                        restoreFocus = true;
                        active.querySelector('[data-nav-link]').focus();
                        restoreFocus = false;
                    }
                }
                if (event.key === 'Tab' && header.hasAttribute('data-drawer-open')) {
                    var focusable = Array.from(drawer.querySelectorAll('a[href], button, input, [tabindex="0"]')).filter(function (el) { return el.getClientRects().length && !el.disabled; });
                    var first = focusable[0];
                    var last = focusable[focusable.length - 1];
                    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
                    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
                }
            });
            document.addEventListener('click', function (event) {
                if (!header.contains(event.target)) closeSections();
            });
            desktop.addEventListener('change', function () { closeSections(); closeDrawer(false); });
            window.addEventListener('pagehide', function () { closeSections(); closeDrawer(false); });
        });
    }
    initNavigation();
    document.addEventListener('astro:page-load', initNavigation);
})();
